
<template>
  <div>
    <vxe-modal
      v-model="companyUserEditDialogVisible"
      :before-hide-method="companyUserEditCloseDialog"
      width="40%"
      show-zoom
      resize
      transfer
    >
      <template #title>
        <span>公司用户</span>
      </template>
      <template #default>
        <div class="hbn-container">
          <div class="search-form">
            <el-row :gutter="24">
              <el-col :span="16">
                <el-form
                  ref="form"
                  :model="form"
                  label-width="80px"
                  label-position="top"
                  size="mini"
                >
                  <el-row :gutter="24">
                    <el-col :span="12">
                      <el-form-item label="用户名称">
                        <el-input
                          id="userName"
                          v-model="PageQuery.queryModel.userName"
                          placeholder="用户名称"
                          clearable
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="手机号">
                        <el-input
                          id="phone"
                          v-model="PageQuery.queryModel.phone"
                          placeholder="手机号"
                          clearable
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </el-col>
              <el-col :span="8">
                <el-form-item style="padding-top: 28px">
                  <el-button
                    size="mini"
                    class="hbn-button-serach"
                    @click="seach"
                    >查找</el-button
                  >
                  <el-button
                    size="mini"
                    type="primary"
                    v-show="showBtnConfirm"
                    @click="btnConfirm"
                    >确定</el-button
                  >
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <div class="hbn-table-screen">
            <div class="custom-table-layer">
              <div style="margin-bottom: 13px">
                <vxe-table
                  :data="DataList"
                  round
                  border
                  height="388"
                  class="mytable-scrollbar"
                  style="width: 100%"
                  :highlight-current-row="true"
                  @checkbox-all="handleSelectionAllChange"
                  @current-change="handleCurrentChange"
                  @checkbox-change="handleSelectionChange"
                  ref="multipleTable"
                  highlight-hover-row
                  highlight-hover-column
                  highlight-current-column
                  show-overflow="tooltip"
                  empty-text="没有更多数据了！"
                  resizable
                  stripe
                >
                  <vxe-table-column
                    fixed="left"
                    type="checkbox"
                    width="40"
                  ></vxe-table-column>
                  <vxe-table-column
                    fixed="left"
                    type="seq"
                    width="55"
                    title="序号"
                    align="center"
                  ></vxe-table-column>

                  <template v-for="(item, key) in DepartmentUserList" :key="key">
                    <vxe-table-column
                      v-if="item.isShow"
                      :field="item.prop"
                      :title="item.label"
                      :width="item.width"
                      align="center"
                      show-overflow-tooltip
                      :class-name="JSON.stringify(item)"
                      :formatter="formatterData"
                    />
                  </template>
                </vxe-table>
              </div>
              <div class="pagination">
                <vxe-pager
                  perfect
                  size="mini"
                  :current-page="PageQuery.pageindex"
                  :page-size="PageQuery.PageSize"
                  :page-sizes="[20, 50, 100, 500]"
                  :total="total"
                  :pager-count="5"
                  :layouts="[
                    'PrevJump',
                    'PrevPage',
                    'JumpNumber',
                    'NextPage',
                    'NextJump',
                    'FullJump',
                    'Sizes',
                    'Total',
                  ]"
                  @page-change="handlePageChange"
                >
                </vxe-pager>
              </div>
            </div>
          </div>
        </div>
      </template>
    </vxe-modal>
  </div>
</template>

<script>
import { Search, Delete } from "@element-plus/icons";

import { GetDataNotInDepartment,AddUserToDepartment } from "@api/Company/ApiDepartmentUser";
import { DepartmentUserList } from "@/assets/apiData/Company/DepartmentUserList";

import Enumerable from "linq";
import XEUtils from "xe-utils";

export default {
  name: "CompanyUserEdit",
  props: {
    companyUserEditDialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      PageQuery: {
        queryModel: {
          userName: "",
          id: 0, //部门Id
        },
        pageindex: 1,
        PageSize: 20,
      },
      total: 0,
      multipleSelection: [],
      UpLoaddialogVisible: false,
      seldata: {
        dialogGUID: "",
        dialogtype: "",
      },
      show: false,
      DepartmentUserList:[],
      DataList: [],
      showBtnConfirm:true,
    };
  },
  components: {},
  computed: {
    checkendSum() {
      return this.multipleSelection.length;
    },
  },
  methods: {
    loadDataById: function (id) {
      this.PageQuery.queryModel.id = id;
      this.PageQuery.queryModel.userName="";
      this.PageQuery.queryModel.phone="";
      this.GetData();
    },
    formatterData: function ({ cellValue, row, column }) {
      return cellValue;
    },
    error() {},
    success() {},
    closeUpDialog() {
      this.UpLoaddialogVisible = false;
    },

    handleClick(index, type) {
      console.log(index, type);

      this.CourseEdit(index, type);
    },
    CourseEdit(index, type) {
      var _this = this;
      if (type == "Delete") {
        DeleteCourse(this.DataList[index].id).then(function (data) {
          if (data) {
            _this.$message.success("删除成功");
            _this.PageQuery.pageindex = 1;
            _this.GetData();
          }
        });
      } else {
        this.companyUserEditDialogVisible = true;
        var id = 0;
        if (type != "Add") id = _this.DataList[index].id;
        this.$refs.CourseEdit.loadDataById(id, type);
      }
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionAllChange(val){
      this.multipleSelection = val;
    },
    //选中事件
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    seach() {
      this.PageQuery.pageindex = 1;
      this.GetData();
    },
    btnConfirm() {
      var _this=this
      var userIds=[];
      _this.multipleSelection.records.forEach(x=>{
        userIds.push(x.id)
      })
      if(userIds.length==0){
        _this.$message.error("必须选择一个用户!");
        return
      }
      _this.showBtnConfirm=false;
      AddUserToDepartment(_this.PageQuery.queryModel.id,userIds).then(x=>{
        _this.$message.success("数据保存成功!");
        _this.showBtnConfirm = true;
        _this.closeDialog();
      })
    },
    companyUserEditCloseDialog(){
      this.$emit("close-dialog");
    },
    handleSizeChange(val) {
      //分页
    },
    handlePageChange({ currentPage, pageSize }) {
      if (this.PageQuery.PageSize != pageSize) {
        this.PageQuery.pageindex = 1; //说明更改了每页展示条数，要从第一页进行展示
        this.PageQuery.PageSize = pageSize;
      } else {
        this.PageQuery.pageindex = currentPage;
      }
      this.GetData();
    },
    handleCurrentChange(val) {
      //debugger
      console.log(val);
      this.GetData();
    },
    GetData() {
      const _this = this;
      if (_this.PageQuery.queryModel.id == "0") {
        return;
      }
      GetDataNotInDepartment(_this.PageQuery).then(function (data) {
        _this.DataList = data.entities;
        _this.total = data.totalCount;
      });
    },
    closeDialog() {
      this.$emit("close-dialog");
    },
  },
  created() {
    this.DepartmentUserList=DepartmentUserList;
  },
};
</script>
<style lang="scss" scoped>
@import "@/common/css/Hbn_modules/reset-input";
.custom-table-header > th {
  background: #dfdfdf !important;
}

.custom-table-header > th > .cell {
  font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
  font-weight: 500;
  color: #868686 !important;
  line-height: 22px;
}

.custom-table-layer ::v-deep .el-table .cell {
  color: #32383d;
}
.el-table .cell {
  color: #32383d;
}

.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {
  display: none;
}
.custom-table-layer .el-pagination.is-background .btn-prev,
.custom-table-layer .el-pagination.is-background .btn-next,
.custom-table-layer .el-pagination.is-background .el-pager li {
  border: 1px solid #acb5bd;
  width: 32px;
  height: 32px;
  line-height: 32px;
  background-color: #fff;
}
</style>
<style lang="scss" scoped>
@import "@/common/css/Hbn_modules/hbn-base-model";
#userInfo {
}
</style>
<style scoped>
</style>
